<template>
	<div>
		<!-- 1 -->
		<svg class="bottle" x="0px" y="0px" viewBox="0 0 60 70">
			<g>
				<defs>
					<polygon id="SVGID_1_" points="-185,-15 -184,-15 -185,-14 						" />
				</defs>
				<clipPath id="SVGID_2_">
					<use xlink:href="#SVGID_1_" style="overflow:visible;" />
				</clipPath>

				<defs>
					<polygon id="SVGID_3_" points="-185,-15 -184,-15 -185,-14 						" />
				</defs>
				<defs>
					<polygon id="SVGID_4_" points="-187,-17 -188,-17 -187,-18 						" />
				</defs>
				<clipPath id="SVGID_5_">
					<use xlink:href="#SVGID_3_" style="overflow:visible;" />
				</clipPath>
				<clipPath id="SVGID_6_" class="st0">
					<use xlink:href="#SVGID_4_" style="overflow:visible;" />
				</clipPath>

				<linearGradient id="SVGID_7_" gradientUnits="userSpaceOnUse" x1="-109.005" y1="-78.09" x2="-109.005"
					y2="-31.31" gradientTransform="matrix(1 0 0 -1 0 -30)">
					<stop offset="0" style="stop-color:#808080" />
					<stop offset="1" style="stop-color:#FFFFFF" />
				</linearGradient>
				<polygon class="st1"
					points="-114.96,1.31 -112.91,21.22 -137.25,48.09 -80.76,48.09 -104.04,21.22 -102.35,1.33 					" />

				<defs>
					<polygon id="SVGID_8_" points="-185,-15 -184,-15 -185,-14 						" />
				</defs>
				<clipPath id="SVGID_9_">
					<use xlink:href="#SVGID_8_" style="overflow:visible;" />
				</clipPath>

				<defs>
					<polygon id="SVGID_10_" points="-185,-15 -184,-15 -185,-14 						" />
				</defs>
				<defs>
					<polygon id="SVGID_11_" points="-187,-17 -188,-17 -187,-18 						" />
				</defs>
				<clipPath id="SVGID_12_">
					<use xlink:href="#SVGID_10_" style="overflow:visible;" />
				</clipPath>
				<clipPath id="SVGID_13_" class="st2">
					<use xlink:href="#SVGID_11_" style="overflow:visible;" />
				</clipPath>

				<linearGradient id="SVGID_14_" gradientUnits="userSpaceOnUse" x1="-108.81" y1="-78.09" x2="-108.81"
					y2="-31.32" gradientTransform="matrix(1 0 0 -1 0 -30)">
					<stop offset="0" style="stop-color:#808080" />
					<stop offset="1" style="stop-color:#FFFFFF" />
				</linearGradient>
				<polygon class="st3"
					points="-112.91,1.32 -111.33,21.22 -133.71,47.67 -83.91,48.09 -106.13,21.22 -104.87,1.33 					" />

				<defs>
					<polygon id="SVGID_15_" points="-185,-15 -184,-15 -185,-14 						" />
				</defs>
				<clipPath id="SVGID_16_">
					<use xlink:href="#SVGID_15_" style="overflow:visible;" />
				</clipPath>
				<defs>
					<polygon id="SVGID_17_" points="-185,-15 -184,-15 -185,-14 						" />
				</defs>
				<defs>
					<polygon id="SVGID_18_" points="-187,-17 -188,-17 -187,-18 						" />
				</defs>
				<clipPath id="SVGID_19_">
					<use xlink:href="#SVGID_17_" style="overflow:visible;" />
				</clipPath>
				<clipPath id="SVGID_20_" class="st4">
					<use xlink:href="#SVGID_18_" style="overflow:visible;" />
				</clipPath>

				<linearGradient id="SVGID_21_" gradientUnits="userSpaceOnUse" x1="-108.81" y1="-35.11" x2="-108.81"
					y2="-29.91" gradientTransform="matrix(1 0 0 -1 0 -30)">
					<stop offset="0" style="stop-color:#808080" />
					<stop offset="1" style="stop-color:#FFFFFF" />
				</linearGradient>
				<polygon class="st5" points="-117.97,-0.09 -116.79,5.11 -101.31,5.11 -99.65,-0.09 					" />


				<linearGradient id="SVGID_22_" gradientUnits="userSpaceOnUse" x1="30" y1="-100" x2="30" y2="-53.22"
					gradientTransform="matrix(1 0 0 -1 0 -30)">
					<stop offset="0" style="stop-color:#CFFFE8" />
					<stop offset="1" style="stop-color:#4AEFB1" />
				</linearGradient>
				<polygon class="st6" points="24.05,23.22 26.09,43.13 1.76,70 58.24,70 34.97,43.13 36.66,23.24 		" />

				<linearGradient id="SVGID_23_" gradientUnits="userSpaceOnUse" x1="30.195" y1="-100" x2="30.195"
					y2="-53.23" gradientTransform="matrix(1 0 0 -1 0 -30)">
					<stop offset="0" style="stop-color:#CFFFE8" />
					<stop offset="1" style="stop-color:#4AEFB1" />
				</linearGradient>
				<polygon class="st7" points="26.09,23.23 27.67,43.13 5.3,69.58 55.09,70 32.88,43.13 34.13,23.24 		" />

				<linearGradient id="SVGID_24_" gradientUnits="userSpaceOnUse" x1="30.195" y1="-57.02" x2="30.195"
					y2="-51.82" gradientTransform="matrix(1 0 0 -1 0 -30)">
					<stop offset="0" style="stop-color:#CFFFE8" />
					<stop offset="1" style="stop-color:#4AEFB1" />
				</linearGradient>
				<polygon class="st8" points="21.03,21.82 22.22,27.02 37.7,27.02 39.35,21.82 		" />

				<linearGradient id="SVGID_25_" gradientUnits="userSpaceOnUse" x1="30.195" y1="-100" x2="30.195"
					y2="-64.53" gradientTransform="matrix(1 0 0 -1 0 -30)">
					<stop offset="0" style="stop-color:#E90088" />
					<stop offset="1" style="stop-color:#DE3129" />
				</linearGradient>
				<polygon class="st9" points="26.99,34.53 33.42,34.53 32.88,43.13 55.09,70 5.3,69.58 27.67,43.13 		" />
				<polygon class="st10" points="21.88,22.23 38.63,22.23 37.49,26.63 34.24,26.63 34.44,22.88 		" />
				<polygon class="st10"
					points="32.63,27.96 31.92,44.04 45.17,69.34 54.15,69.91 33.59,42.46 35.24,27.96 		" />
				<polygon class="st10"
					points="25.13,27.96 26.73,43.09 4.62,69.59 16.74,69.59 28.98,42.09 27.73,28.55 		" />
				<path class="st11" d="M35.6,57.77c0,1.25-1.01,2.26-2.26,2.26s-2.26-1.01-2.26-2.26s1.01-2.26,2.26-2.26
			C34.59,55.51,35.6,56.52,35.6,57.77z" />
				<path class="st11" d="M32.38,51.36c0,0.35-0.29,0.64-0.64,0.64c-0.36,0-0.64-0.29-0.64-0.64c0-0.36,0.29-0.64,0.64-0.64
			S32.38,51,32.38,51.36z" />
				<path class="st11" d="M22.95,60.55c0,1.54-1.25,2.79-2.79,2.79s-2.79-1.25-2.79-2.79s1.25-2.79,2.79-2.79
			C21.7,57.77,22.95,59.01,22.95,60.55z" />
				<circle class="st11" cx="41.45" cy="62.23" r="1.68" />
			</g>
		</svg>
	</div>
</template>

<script>
  export default {
    name: 'bottle1'
  }
</script>

<style scoped>
.bottle {
	position: fixed;
	height: 20vh;
	top: 40vh;
	left: 19vw;
	animation: text-shadow 1.5s ease-in-out infinite;
	animation-delay: .2s;
}

@keyframes text-shadow {
    0% {  
        transform: translateY(0);
		filter: drop-shadow(0 0 9px #333);
    }

    25% {  
        transform: translateY(-0.5em);
		filter: drop-shadow(0 0 9px #333);
    }

    50% {  
        transform: translateY(0.5em);
		filter: drop-shadow(0 0 18px #DE3129);
    }
    
   75% {
        transform: translateY(-0.25em);
		filter: drop-shadow(0 0 9px #333);
    }

    100% {  
        transform: translateY(0);
		filter: drop-shadow(0 0 9px #333);
    }
}

.st0{clip-path:url(#SVGID_5_);}
	.st1{clip-path:url(#SVGID_6_);fill:url(#SVGID_7_);}
	.st2{clip-path:url(#SVGID_12_);}
	.st3{clip-path:url(#SVGID_13_);fill:url(#SVGID_14_);}
	.st4{clip-path:url(#SVGID_19_);}
	.st5{clip-path:url(#SVGID_20_);fill:url(#SVGID_21_);}
	.st6{fill:url(#SVGID_22_);}
	.st7{fill:url(#SVGID_23_);}
	.st8{fill:url(#SVGID_24_);}
	.st9{fill:url(#SVGID_25_);}
	.st10{opacity:0.5;fill:#FFFFFF;enable-background:new    ;}
	.st11{fill:#FFFFFF;}

</style>
